module.exports = __webpack_public_path__ + "static/media/tazzina.00bf52aa.png";